import { useAtom } from '@reatom/react';
import { publicApi } from 'api';

import { declareResource, useResource } from '../../libs/reatom-toolkit';

const aboutUs = declareResource('About Us', null, async () => {
  const { data } = await publicApi.get(`/information-pages`);
  return data.filter(item => item.type === 0)[0];
});

export function useAboutUs() {
  const { get, isLoading, error } = useResource(aboutUs);

  return {
    isLoading,
    error,
    getAboutUsData: get,
    aboutUsData: useAtom(aboutUs),
  };
}
